import styled from "styled-components";
import { REGULAR_TEXT } from "../colors";
import PageHeading from "./PageHeading";

export default styled(PageHeading)`
  color: ${REGULAR_TEXT};
`;
